import React, { useEffect } from 'react';
import logo from './logo.svg';
import './App.css';
import 'react-notifications/lib/notifications.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  Redirect,
  useLocation, Navigate
} from "react-router-dom";

import { connect } from 'react-redux';
// import {Actions as MYACTIONS} from './store/actions/myActions';
// import {Actions as TEAMACTIONS} from './store/actions/teamActions';
import { Actions as AUTHENTICATIONACTIONS } from './store/actions/authenticationActions';
import { NotificationContainer } from 'react-notifications';

// Components -------------------------------------------------------------------------------------------------------------

import Navbar from './components/common/Navbar'
import MoorepayBanner from './components/common/MoorepayBanner'
import MarketingBanner from './components/common/MarketingBanner'
import CountryDialog from './components/common/CountryDialog'
import Footer from './components/common/Footer'
import OnPageChange from './components/common/OnPageChange'
// import Sidebar from './components/common/Sidebar'
import Login from './components/login/Login'
import SetPassword from './components/login/SetPassword'
import ScrollToTop from './ScrollToTop'

// Pages -------------------------------------------------------------------------------------------------------------------

import Home from './pages/Home'
import HomeMT from './pages/mt/Home'
// import UkEarlyAccess from './pages/uk/UkEarlyAccess'
import UkDemo from './pages/uk/UkDemo'
import Payslip from './pages/Payslip'
import Childcare from './pages/industry/Childcare'
import Accountants from './pages/industry/Accountants'
import PayrollBureau from './pages/industry/PayrollBureau'
import Register from './pages/Register'
import Employer from './pages/industry/Employer'
import Employee from './pages/industry/Employee'
import Terms from './pages/Terms'
import Privacy from './pages/Privacy'
import DataProcessingPolicy from './pages/DataProcessingPolicy'
import DataProcessingAgreement from './pages/DataProcessingAgreement'
import ResponsibleDisclosure from './pages/ResponsibleDisclosure'
import Subprocessors from './pages/Subprocessors'
import Covid from './pages/Covid'
import Pricing from './pages/Pricing'
import BureauPricing from './pages/BureauPricing'
import Figolli from './pages/Figolli'
import About from './pages/About'
import AdventCalendar from './pages/AdventCalendar'
// import CyberMonday from "./pages/CyberMonday";

import Xero from './pages/Xero'
import PayrollGuide from './pages/PayrollGuide'
import WebinarSeries from './pages/WebinarSeries'
import Webinar from './pages/Webinar'
import SalaryCalculator from 'pages/SalaryCalculator'
import NoticePeriodCalculator from 'pages/NoticePeriodCalculator'
// import Course from './pages/course/Course';
// import CourseDetails from 'pages/course/CourseDetails';

// Partner Details
import Partners from 'pages/partner/Partners';
import Partner from 'pages/partner/Partner';

import ReactPixel from 'react-facebook-pixel';
import { onCookieConsent } from './utils/cookieConsent';
import NotFound from 'pages/NotFound';
// import CourseModule from 'pages/course/Module';
import Article from 'pages/ArticleHOC';
import Articles from 'pages/Articles';
// import Blog from 'pages/Blog';
import IsBuddyForYou from 'pages/IsBuddyForYou';
import ColaReport from 'pages/ColaReport';
import MFAVerification from 'components/login/MFAVerification';
import MFASetup from 'components/login/MFASetup';


// Malta Landing Pages
import MaltaAccountantsLanding from './pages/mt/MaltaAccountantsLanding';
import MaltaBusinessLanding from './pages/mt/MaltaBusinessLanding';
// const advancedMatching = { em: 'some@email.com' }; // optional, more info: https://developers.facebook.com/docs/facebook-pixel/advanced/advanced-matching
const options = {
  autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
  debug: false, // enable logs
};
onCookieConsent('marketing', () => ReactPixel.init('310994956063533', {}, options));
// import history from "./utils/history";

const savedCountry = localStorage.getItem("country");

function App({
  // myGetAgreements,
  // getDepartments,
  loggedIn,
  profile,
  isLoggedIn,
  hasMFA,
	mfaExpires,
  isAdmin,
  companySettings
  // showSidebar,
}) {

  useEffect(() => {
    isLoggedIn()
  }, []);
  /*useEffect(() => {
    // load initial data required for anywhere
    if (loggedIn){
      // myGetAgreements()
      // getDepartments()
    }
  },[loggedIn]);

  if (!loggedIn && window.location.pathname.includes("set")){
    return (
      <SetPassword/>
    )
  } else if (!loggedIn) {
    return (
      <Login/>
    )
  }*/

  const pageClass = ""

  if (loggedIn && !hasMFA && (isAdmin || !mfaExpires && companySettings?.mfaRequirement)) {
    return (
      <div style={{ height: "100vh", width: "100%", display: "flex", placeContent: "center", alignItems: "center" }}>
        <MFASetup companyRequired={true} />
        <NotificationContainer />
      </div>
    )
  }

  if (loggedIn && hasMFA && (!mfaExpires || mfaExpires <= new Date().toISOString())) {
		return (<>
			<MFAVerification />
      <NotificationContainer />
    </>
		);
	}


  return (

    <Router>
        <NotificationContainer />
      <ScrollToTop />
      <div className={`relative ${window.location.pathname.startsWith("/set/") ? "" : "bg-gray-800"}`}>

        <div className={`relative ${window.location.pathname.startsWith("/set/") ? "" : ""}`}>
          <MoorepayBanner />
          <Navbar />
          <MarketingBanner />
          <CountryDialog />

          <Routes>
            <Route path="*" element={<NotFound/>} />
            <Route path="/not-found" element={<NotFound/>} />

            <Route path="/login" element={<Login/>} />
            <Route path="/login/sso" element={<Login/>} />
            <Route path="/set/:employeeID/:recoveryCode" element={<SetPassword/>} />

            <Route path="/">
              <Route path="/" index element={<Home />}/>
              <Route path="/:country">
                <Route index element={<Home />}/>
                <Route path="/:country/start" element={<Register/>} />
                <Route path="/:country/join" element={<Register/>} />
                <Route path="/:country/employer" element={<Employer/>} />
                <Route path="/:country/employer/start" element={<Register for="Employer"/>} />
                <Route path="/:country/employee" element={<Employee/>} />
                <Route path="/:country/payroll-bureau" element={<PayrollBureau/>} />
                <Route path="/:country/payroll-bureau/start" element={<Register for="Bureau" withPaymentInfo={false}/>} />
                <Route path="/:country/employer/pricing" element={<Pricing/>} />
                <Route path="/:country/payroll-bureau/pricing" element={<BureauPricing/>} />
                <Route path="/:country/a/:slug" element={<Article/>} />
                <Route path="/:country/articles" element={<Articles/>} />
                <Route path="/:country/about" element={<About/>} />
                <Route path="/:country/figolla" element={<Figolli/>} />


                <Route path="/:country/webinar/:slug" element={<Webinar/>} />
                <Route path="/:country/webinar" element={<WebinarSeries/>} />


                {/* <Route path="/:country/learn/:courseSlug/:moduleSlug" element={<CourseModule/>} />
                <Route path="/:country/learn/:courseSlug" element={<CourseDetails/>} />
                <Route path="/:country/learn" element={<Course/>} /> */}
                <Route path="/:country/terms" element={<Terms/>} />
                <Route path="/:country/privacy" element={<Privacy/>} />
                <Route path="/:country/data-processing-policy" element={<DataProcessingPolicy/>} />
                <Route path="/:country/data-processing-agreement" element={<DataProcessingAgreement/>} />
                <Route path="/:country/subprocessors" element={<Subprocessors/>} />
                <Route path="/:country/security" element={<ResponsibleDisclosure/>} />
                <Route path="/:country/xero" element={<Xero/>} />

                <Route path="/:country/advent-calendar" element={<AdventCalendar/>} />

                {/*<Route path="/:country/partners/details" element={<Partner/>} />
                <Route path="/:country/partners" element={<Partners/>} />*/}

                <Route path="*" element={<NotFound/>} />
              </Route>

              {/* Below are invites for the UK - ideally we use a param to switch MT/UK and make it work for both */}
              <Route exact path="/uk/invite" element={<UkDemo/>} />
              <Route exact path="/uk/invite/:code" element={<UkDemo/>} />
              <Route path="/uk/budget-report" element={<ColaReport jurisdiction="uk"/>} />

              <Route path="/mt/payroll-guide" element={<PayrollGuide/>} />
              <Route path="/mt/salary-calculator" element={<SalaryCalculator/>} />
              <Route path="/mt/cola-report" element={<ColaReport jurisdiction="mt"/>} />
              <Route path="/mt/notice-period-calculator" element={<NoticePeriodCalculator/>} />
              <Route path="/mt/payslip-malta" element={<Payslip/>} />
              {/* <Route path="/mt/cyber-monday" element={<CyberMonday/>} /> */}
              <Route path="/mt/is-buddy-for-you" element={<IsBuddyForYou/>} />

              {/* Needs to be converted to new design block and made agnostic */}
              <Route path="/mt/childcare-payroll" element={<Childcare/>} />

            </Route>

            {/*<Route exact path="/uk/early-access" element={<UkEarlyAccess/>} />*/}

            <Route path="*" element={<NotFound/>} />


            <Route path="/payroll-guide" element={<Navigate to={`/${savedCountry ?? 'mt'}/payroll-guide`} replace />} />
            <Route path="/salary-calculator" element={<Navigate to={`/${savedCountry ?? 'mt'}/salary-calculator`} replace />} />
            <Route path="/cola-report" element={<Navigate to={`/${savedCountry ?? 'mt'}/cola-report`} replace />} />
            <Route path="/notice-period-calculator" element={<Navigate to={`/${savedCountry ?? 'mt'}/notice-period-calculator`} replace />} />
            <Route path="/payslip-malta" element={<Navigate to={`/${savedCountry ?? 'mt'}/payslip-malta`} replace />} />
            <Route path="/childcare-payroll" element={<Navigate to={`/${savedCountry ?? 'mt'}/childcare-payroll`} replace />} />
            <Route path="/pricing" element={<Navigate to={`/${savedCountry ?? 'mt'}/pricing`} replace />} />
            <Route path="/articles" element={<Navigate to={`/${savedCountry ?? 'mt'}/articles`} replace />} />
            <Route path="/blog" element={<Navigate to={`/${savedCountry ?? 'mt'}/articles`} replace />} />
            <Route path="/webinar" element={<Navigate to={`/${savedCountry ?? 'mt'}/webinar`} replace />} />
            <Route path="/about" element={<Navigate to={`/${savedCountry ?? 'mt'}/about`} replace />} />
            <Route path="/figolla" element={<Navigate to={`/${savedCountry ?? 'mt'}/figolla`} replace />} />
            {/* <Route path="/learn" element={<Navigate to={`/${savedCountry ?? 'mt'}/learn`} replace />} /> */}
            <Route path="/terms" element={<Navigate to={`/${savedCountry ?? 'mt'}/terms`} replace />} />
            <Route path="/privacy" element={<Navigate to={`/${savedCountry ?? 'mt'}/privacy`} replace />} />
            <Route path="/data-processing-agreement" element={<Navigate to={`/${savedCountry ?? 'mt'}/data-processing-agreement`} replace />} />
            <Route path="/subprocessors" element={<Navigate to={`/${savedCountry ?? 'mt'}/subprocessors`} replace />} />
            <Route path="/security" element={<Navigate to={`/${savedCountry ?? 'mt'}/security`} replace />} />
            <Route path="/xero" element={<Navigate to={`/${savedCountry ?? 'mt'}/xero`} replace />} />
            <Route path="/is-buddy-for-you" element={<Navigate to={`/${savedCountry ?? 'mt'}/is-buddy-for-you`} replace />} />

            {/* Malta Landing Pages */}
            <Route path="/mt/accountants-switch-payroll" element={<MaltaAccountantsLanding />} />
            <Route path="/mt/business-switch-payroll" element={<MaltaBusinessLanding />} />

          </Routes>

          <OnPageChange />
          <Footer />
        </div>
      </div>
    </Router>
  );
}

const mapStateToProps = (state) => {

  // const {
  //   myAgreements,
  // } = state.my

	const { hasMFA, mfaExpires } = state.my.profile || {};
  return {
    // showSidebar: state.sidebar.show,
    loggedIn: state.my.profile ? true : false,
    profile: state.my.profile,
    hasMFA: state?.my?.profile?.hasMFA ? true : false,
    mfaExpires,
    hasMFA,
    isAdmin: state.my?.profile?.isAdmin,
    companySettings: state.company?.settings,
  }
}

const mapDispatchToProps = dispatch => ({
  // myGetAgreements: () => dispatch(MYACTIONS.myGetAgreements()),
  // getProfile: () => dispatch(MYACTIONS.getProfile()),
  isLoggedIn: () => dispatch(AUTHENTICATIONACTIONS.isLoggedIn()),
  // getDepartments: () => dispatch(TEAMACTIONS.getDepartments()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App)
